class SoundManager {
  constructor() {
    this.audioMapper = {};
    this.isPause = false;
  }
  playAudio(src, name, callback) {
    if (this.audioMapper[name]) {
      if (this.audioMapper[name].audio.readyState > 0) {
        this.audioMapper[name].audio.pause();
      }
    }
    let self = this;
    this.audioMapper[name] = { audio: new Audio(src), callback: callback };
    this.audioMapper[name].audio.addEventListener("ended", function () {
      self.audioMapper[name] = null;
      if (callback) {
        callback();
      }
    });
    if (!this.isPause) {
      this.audioMapper[name].audio.play();
    } else {
      this.audioMapper[name].keep = true;
    }
    return this.audioMapper[name].audio;
  }

  asyncPlayAudio(src, tag) {
    return new Promise((resolve, reject) => {
      this.playAudio(src, tag, () => {
        resolve();
      });
    });
  }

  stopAudio(name) {
    if (this.audioMapper[name]) {
      if (this.audioMapper[name].audio.readyState > 0) {
        this.audioMapper[name].audio.pause();
        this.audioMapper[name] = null;
      }
    }
  }

  stopAllAudio() {
    for (let [key, value] of Object.entries(this.audioMapper)) {
      this.stopAudio(key);
    }
  }
}

const audio_click = () => {
  const audio_click = new Audio("media/mouseclick.mp3");
  const audio_move_page = new Audio("media/booksori.mp3");

  audio_click.play();
};

const audio_move_page = () => {
  const audio_move_page = new Audio("media/booksori.mp3");

  audio_move_page.play();
};

const audio_correct = () => {
  const audio_correct = new Audio("media/correct.mp3");

  audio_correct.play();
};

const audio_incorrect = () => {
  const audio_incorrect = new Audio("media/incorrect.mp3");

  audio_incorrect.play();
};


export { audio_click, audio_move_page, audio_correct, audio_incorrect, SoundManager };
